module.exports = __webpack_public_path__ + "static/fipcrainbowsafari-c5682e1af5acd8ebe9b45c5663e18c57.jpeg";